// Delegated permissions used by Outlook methods and realtime services, plus shared mailbox permissions for future support.
// Source: https://learn.microsoft.com/en-us/graph/permissions-reference
export const MICROSOFT_OAUTH_SCOPE_GROUPS = [
  {
    label: 'Identity',
    sourceUrl: 'https://learn.microsoft.com/en-us/graph/permissions-reference#userread',
    scopes: ['User.Read'],
  },
  {
    label: 'Mail',
    sourceUrl: 'https://learn.microsoft.com/en-us/graph/permissions-reference#mailread',
    scopes: [
      'Mail.Read',
      'Mail.ReadWrite',
      'Mail.Send',
      'Mail.Read.Shared',
      'Mail.ReadWrite.Shared',
      'Mail.Send.Shared',
      'MailboxSettings.ReadWrite',
    ],
  },
  {
    label: 'Calendar',
    sourceUrl: 'https://learn.microsoft.com/en-us/graph/permissions-reference#calendarsread',
    scopes: ['Calendars.Read', 'Calendars.ReadWrite', 'Calendars.Read.Shared', 'Calendars.ReadWrite.Shared'],
  },
  {
    label: 'Contacts',
    sourceUrl: 'https://learn.microsoft.com/en-us/graph/permissions-reference#contactsread',
    scopes: ['Contacts.Read'],
  },
];

export const MICROSOFT_OAUTH_SCOPES = MICROSOFT_OAUTH_SCOPE_GROUPS.flatMap((group) => group.scopes);
export const MICROSOFT_REQUIRED_OAUTH_SCOPES = ['User.Read'];
